import types from '../types'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

const server = getApiServer()

export const saveWrapUp = (encounter, notes) => async (dispatch, getState) => {
  const { wrapup: { editingNote } } = getState()
  dispatch({ type: types.SAVE_WRAP_UP_REQUESTED })
  try {
    if (editingNote) {
      dispatch({ type: types.SAVE_WRAP_UP_REJECTED, payload: 'Please finish editing assembled note before saving.' })
    } else {
      
      await axios.post(server + '/api/notes', { encounter, notes })
      dispatch({ type: types.SAVE_WRAP_UP_FULFILLED })
    }
  } catch (error) {
    dispatch({ type: types.SAVE_WRAP_UP_REJECTED, payload: error })
  }
  
}

export const clearWrapUp = () => (dispatch) => {
  dispatch({ type: types.CLEAR_WRAP_UP })
}

export const createAppointmentsRequest = (scheduling) => async (dispatch) => {
  dispatch({ type: types.CREATE_APPOINTMENT_REQUESTED })
  try {
    const appointments = await axios.post(server + '/api/schedule', { scheduling }, { withCredentials: true })
    dispatch({ type: types.CREATE_APPOINTMENT_FULFILLED, payload: appointments.data })
  } catch (error) {
    console.log(error)
    dispatch({ type: types.CREATE_APPOINTMENT_REJECTED, payload: error })
  }
}

export const createDocumentReference = (notes) => async (dispatch) => {
  dispatch({ type: types.CREATE_DOCUMENT_REQUESTED })
  try {
    const sentNote = await axios.post(server + '/api/document', { notes }, { withCredentials: true })
    dispatch({ type: types.CREATE_DOCUMENT_FULFILLED, payload: sentNote.data })
  } catch (error) {
    console.log(error)
    dispatch({ type: types.CREATE_DOCUMENT_REJECTED, payload: error })
  }
}

export const setEditNote = (editing) => (dispatch) => {
  dispatch({ type: types.SET_EDITING_NOTE, payload: editing })
}

export const saveS2K = (score) => async (dispatch) => {
  dispatch({ type: types.SAVE_S2K_REQUESTED })
  try {
    const savedS2k = await axios.post(server + '/api/epic-s2k', { score }, { withCredentials: true })
    if (savedS2k.data.Success) {
      dispatch({ type: types.SAVE_S2K_FULFILLED, payload: savedS2k.data })
    } else {
      dispatch({ type: types.SAVE_S2K_REJECTED, payload: savedS2k.data.Errors[0].Message })
    }
  } catch (error) {
    dispatch({ type: types.SAVE_S2K_REJECTED, payload: error })
  }
}

export const setOrders = (orders) => (dispatch) => dispatch({ type: types.SET_ORDERS, payload: orders })
